import { store } from "../store";
import { panic } from "../actions/store/app-actions";

export interface WebsocketMessage<T> {
	type: "change" | "init";
	action: "add" | "update" | "delete";
	model: "reservation" | "inquiry" | "occupied-day" | "payment";
	origin: string;
	count: number;
	payload: T;
}

type MessageListener = (data: WebsocketMessage<any>) => void;

export class WebsocketClient {
	private socket: WebSocket;
	private messageListeners: MessageListener[] = [];
	private retryCount = 0;

	public connect(url?: string) {
		if (!url) {
			const host = location.host;
			const secure = location.protocol.indexOf("https") > -1;

			url = (secure ? "wss" : "ws") + "://" + host + "/ws";
		}

		if (!this.socket) {
			this.socket = new WebSocket(url);
			this.listen();
		}
	}

	public disconnect() {
		if (this.socket) {
			this.socket.close();
		}
	}

	public on(listener: MessageListener) {
		this.messageListeners.push(listener);
	}

	private listen() {
		this.socket.onmessage = (event: MessageEvent) => {
			const payload = JSON.parse(event.data);

			this.messageListeners.forEach(l => {
				l(payload);
			});
		};

		this.socket.onclose = (event: CloseEvent) => {
			this.socket = null;

			if (!event.wasClean) {
				if (this.retryCount < 5) {
					this.retryCount++;

					setTimeout(() => {
						this.connect();
					}, 1000);
				} else {
					store.dispatch(panic());
				}
			}
		};
	}
}
